<template>
  <b-modal
    :title="`Cambiar privacidad a expediente #${file.numero}`"
    v-model="showModal"
    size="lg"
    hide-footer
    centered
    no-close-on-backdrop
  >
    <b-overlay :show="loading">
      <div class="row">
        <div class="col-12 text-center">
          <h3>
            ¿Deseas cambiar la privacidad del expediente a
            <strong>{{ file.transportePuertoTipo === '0' ? 'Público' : 'Privado' }}</strong>?
          </h3>
          <b-form-select
            :options="optionsIsPrivate"
            v-model="privacity"
            class="mt-3"
          ></b-form-select>
        </div>
        <div class="col-12 text-right  mt-5">
          <b-button
            data-cy="send-docdigital"
            variant="primary"
            @click="send"
          >
            Confirar
          </b-button>
        </div>
      </div>
    </b-overlay>
  </b-modal>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

import { PRIVACITY } from '@/febos/chile/dnt/config/constants/exp/privacity';

export default {
  name: 'PopUpUpdatePrivacity',
  components: {},
  props: {
    file: {
      type: [Object],
      required: true,
      default: () => {
      }
    }
  },
  data() {
    return {
      privacity: this.file.transportePuertoTipo || '0',
      optionsIsPrivate: [
        { value: PRIVACITY.PUBLIC, text: 'Público' },
        { value: PRIVACITY.CONFIDENTIAL, text: 'Privado' },
        { value: PRIVACITY.RESERVED, text: 'Reservado' },
      ],
    };
  },
  computed: {
    ...mapGetters('Modals', [
      'modalName'
    ]),
    ...mapGetters('Usuario', [
      'currentUser'
    ]),
    ...mapGetters('Dnts', [
      'detailsFile'
    ]),
    ...mapGetters('docDigital', [
      'documentType',
      'entity',
      'loading'
    ]),
    showModal: {
      get() {
        return this.modalName === 'updatePrivacity';
      },
      set() {
        this.closeModal();
      }
    }
  },
  watch: {},
  methods: {
    ...mapActions('Modals', [
      'closeModal'
    ]),
    ...mapActions('Dnts', [
      'actualizarCampos'
    ]),

    async send() {
      const body = {
        dnt: [
          { op: 'update', campo: 'transportePuertoTipo', valor: this.privacity }
        ]
      };

      this.loadingToSend = true;

      const payload = {
        id: this.file.febosId,
        payload: body

      };
      await this.actualizarCampos(payload);
      this.closeModal();
      this.$emit('reload');
    },

  }
};
</script>
